export default __webpack_public_path__ + "d0c722d8172fc7b38a7bf319f0faa3b2.pdf";